// ============================================================
// CONFIGURACIÓN EDITABLE DE LA WEB — DentalAi
// Cambia aquí los datos de contacto y textos legales.
// ============================================================

export const SITE = {
  name: "DentalAi",
  tagline: "IA para reducir no-shows y recuperar horas de sillón en clínicas dentales.",
  email: "usedentalai@gmail.com",
  phoneDisplay: "+34 633 230 576",
  phoneHref: "tel:+34633230576",
  whatsappNumber: "34633230576",
  whatsappMessage:
    "Hola, vengo de la web de DentalAi y quiero información para mi clínica dental.",
};

export const WHATSAPP_URL = `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(
  SITE.whatsappMessage
)}`;

// Textos legales (pendientes de personalizar por el titular de la web)
export const LEGAL_TEXTS = {
  privacidad: {
    title: "Política de privacidad",
    body: `Texto legal pendiente de personalizar por el titular de la web.

Los datos enviados a través del formulario de auditoría se utilizan únicamente para analizar la solicitud y contactar con la clínica en relación con la auditoría solicitada.

Responsable: ${SITE.name} — ${SITE.email}.

Antes de activar cada canal de comunicación (WhatsApp, SMS, email o llamada automática), la clínica debe revisar sus obligaciones legales y contractuales en materia de protección de datos.`,
  },
  aviso: {
    title: "Aviso legal",
    body: `Texto legal pendiente de personalizar por el titular de la web.

${SITE.name} es un servicio de automatización de comunicaciones administrativas para clínicas dentales. No presta servicios clínicos, no toma decisiones clínicas ni sustituye el criterio del equipo de la clínica.

Las cifras económicas mostradas en esta web son estimaciones orientativas y no constituyen una garantía de resultados.`,
  },
  cookies: {
    title: "Política de cookies",
    body: `Texto legal pendiente de personalizar por el titular de la web.

Esta web puede utilizar cookies técnicas y de análisis para mejorar la experiencia de navegación y medir conversiones.`,
  },
};
